import { Modify } from 'shared/lib/utils';
import { RelevantDomains } from 'shared/lib/domains';

// Server types

export type AssignmentsResponse = AssignmentsPayload[];

export type AssignmentsPayload = {
  businessKey: string;
  createdDate: number;
  lastUpdated: number;
  creatorBk: string;
  classBks: string[];
  assignedContent: {
    type?: string;
    contentBusinessKey: string;
    content: AssignmentContentPayload;
  }[];
  startDate?: number | null;
  dueDate?: number | null;
  districtKey?: string;
  studentStatuses?: StudentStatus[];
  archived?: boolean;
  sender?: string;
  enrollmentType?: string;
};

export type EditAssignmentPayload = Omit<
  AssignmentsPayload,
  | 'lastUpdated'
  | 'createdDate'
  | 'creatorBk'
  | 'districtKey'
  | 'studentStatuses'
>;

export type AssignmentContentPayload = {
  domain: string;
  chapterKey?: string;
  cardstackKey?: string;
  cardstackTitle?: string;
  chapterTitle?: string;
  lessonKey?: string;
  lessonTitle?: string;
  title?: string;
  unitKey?: string;
  unitRevision?: string;
  unitRevisionAlias?: string;
  unitTitle?: string;
  lessonThumbnailImagePath?: string;
  isSubmittable?: boolean;
  isActivityActive?: boolean;
  hasWorksheet?: boolean;
  previewThumbnails?: unknown[] | string;
  customContentId?: string;
  thumbURL?: string;
  dashboardURL?: string;
  activityLandingPageURL?: string;
  id?: string; // instance id
  creationDate?: string;
  activityId?: string;
  studentURL?: string;
  studentGreetingURL?: string;
  subject?: string;
  classCode?: string;
};

// Transformed types

export type DesmosAssignment = Modify<
  Omit<AssignmentsPayload, 'assignedContent'>,
  {
    type: 'desmos';
    createdDate: number;
    startDate: number | null;
    dueDate: number | null;
    content: AssignmentContent;
  }
>;

export type CardstackAssignment = Modify<
  Omit<AssignmentsPayload, 'assignedContent'>,
  {
    type: 'Cardstack';
    createdDate: number;
    startDate: number | null;
    dueDate: number | null;
    content: AssignmentContent[];
  }
>;

export type SingleAssignment = Modify<
  Omit<AssignmentsPayload, 'assignedContent'>,
  {
    type: 'Lesson';
    createdDate: number;
    startDate: number | null;
    dueDate: number | null;
    content: AssignmentContent;
  }
>;

export type Assignment =
  | SingleAssignment
  | CardstackAssignment
  | DesmosAssignment;

export type AssignmentContent = Modify<
  AssignmentContentPayload,
  { domain: RelevantDomains }
> & {
  brand: Brand;
  contentBusinessKey: string;
};

export enum Brand {
  REGULAR = 'regular',
  CUSTOMIZED = 'customized',
  CUSTOM = 'custom',
}

export type StudentStatus = {
  studentBusinessKey: string;
  createdDate: number;
  status: AssignmentStatus;
  contentStatuses?: {
    status: AssignmentStatus;
    contentBusinessKey: string;
  }[];
};

export type AssignmentStatus = 'TODO' | 'READ';
